import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { Close } from "@mui/icons-material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useIconButtonsStyle } from "style/iconButtons.style";

export const ClearFilterButton: FunctionComponent<IconButtonProps> = (props) => {
  const { classes: { small, green } } = useIconButtonsStyle();
  const { t } = useTranslation();

  return (
    <Tooltip title={t("clear_all_filters")}>
      <IconButton {...props} color="primary" aria-label="clear_all_filters" className={[small, green].join(" ")}>
        <Close color="primary" />
      </IconButton>
    </Tooltip>
  );
};
